import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateService } from '@services/app-state.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GermanCalculatorResultDTO } from '../types/dto/german-calculator.dto.types';
import { GermanPensionCalculatorResultDTO } from '../types/dto/pension-calculator.dto.types';
import { GermanPensionEstimatorResultDTO } from '../types/dto/pension-estimator.dto.types';
import { ShortfallClosureResultDTO } from '../types/dto/shortfall-closure-calculator.dto.types';
import {
  GermanCalculatorAPIRequestParams,
  GermanCalculatorType,
  GermanPensionCalculatorFormBindValues,
} from '../types/german-calculator.type';

@Injectable({
  providedIn: 'root',
})
export class GermanCalculatorAPIService {
  constructor(
    private httpClient: HttpClient,
    private appStateService: AppStateService
  ) {}

  getResult(
    calculatorType: GermanCalculatorType,
    requestParams: GermanCalculatorAPIRequestParams
  ): Observable<GermanCalculatorResultDTO> {
    return this.httpClient
      .get<{ Result: GermanCalculatorResultDTO }>(
        this.getURL(calculatorType, requestParams)
      )
      .pipe(map((response) => response?.Result));
  }

  getResultPensionCalulator(
    calculatorType: GermanCalculatorType,
    requestParams: GermanPensionCalculatorFormBindValues
  ): Observable<GermanPensionCalculatorResultDTO> {
    return this.httpClient
      .get<{ Result: GermanPensionCalculatorResultDTO }>(
        this.getURL(calculatorType, requestParams)
      )
      .pipe(map((response) => response?.Result));
  }

  getResultPensionEstimator(
    calculatorType: GermanCalculatorType,
    requestParams: GermanPensionCalculatorFormBindValues
  ): Observable<GermanPensionEstimatorResultDTO> {
    return this.httpClient
      .get<{ Result: GermanPensionEstimatorResultDTO }>(
        this.getURL(calculatorType, requestParams)
      )
      .pipe(map((response) => response?.Result));
  }

  getResultShortfallClosure(
    calculatorType: GermanCalculatorType,
    requestParams: GermanPensionCalculatorFormBindValues
  ): Observable<ShortfallClosureResultDTO> {
    return this.httpClient
      .get<{ Result: ShortfallClosureResultDTO }>(
        this.getURL(calculatorType, requestParams)
      )
      .pipe(map((response) => response?.Result));
  }

  getURL(
    calculatorType: GermanCalculatorType,
    requestParams:
      | GermanCalculatorAPIRequestParams
      | GermanPensionCalculatorFormBindValues
  ): string {
    let url: string;
    if (calculatorType === GermanCalculatorType.SAVINGS_PLAN) {
      url = this.appStateService.getGermanCalculatorSavingPlanApiUrl();
    } else if (calculatorType === GermanCalculatorType.ONE_TIME_INVESTMENT) {
      url = this.appStateService.getGermanCalculatorOnetimeInvestmentApiUrl();
    } else if (calculatorType === GermanCalculatorType.WITHDRAWL_PLAN) {
      url = this.appStateService.getGermanCalculatorWithdrawlPlanApiUrl();
    } else if (calculatorType === GermanCalculatorType.PENSION) {
      url = this.appStateService.getGermanCalulatorPensionApiUrl();
    } else if (calculatorType === GermanCalculatorType.PENSION_ESTIMATOR) {
      url = this.appStateService.getGermanCalulatorPensionEstimatorApiUrl();
    } else if (calculatorType === GermanCalculatorType.SHORTFALL_CLOSURE) {
      url = this.appStateService.getGermanCalulatorShortfallClosureApiUrl();
    }
    url = url + '?' + this.getParams(requestParams);
    return url;
  }

  getParams(
    requestParams:
      | GermanCalculatorAPIRequestParams
      | GermanPensionCalculatorFormBindValues
  ): string {
    let paramUrl = '';
    if (requestParams) {
      const objectentries = Object.entries(requestParams);
      for (const entry of objectentries) {
        paramUrl = paramUrl + '&' + entry[0] + '=' + entry[1];
      }
    }
    return paramUrl;
  }
}
